<template lang="pug">
  .set-goal-modal
    .modal-card
      .modal-card-head
          .is-size-3 Change Step Goal
      .modal-card-body
        .label.has-text-grey
          | Step Goal
        BInput(
          v-model="stepGoalValue"
          @input="e => $emit('updateStepGoal', e.value)"
          v-validate="'numeric'"
          name="stepGoal"
        )
        .custom-footer
          WtButton(isText color="grey" @click.native="$parent.close()") CANCEL
          WtButton(
            @click.native="saveGoal"
            :loading="saving"
          ) SAVE

</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import MakeAnEntryFooter from "@@/Members/MakeAnEntry/MakeAnEntryFooter";
import { mapActions } from "vuex";

export default {
  name: "TodaysProgressModal",

  components: {
    WtButton,
    WtTitle,
    MakeAnEntryFooter
  },

  props: {
    stepGoal: {
      type: Number,
      required: true,
      default: 0
    }
  },

  data() {
    return {
      formData: new FormData(),
      uniqueKey: "",
      stepGoalValue: this.stepGoal,
      saving: false
    };
  },
  methods: {
    ...mapActions("members", ["updateMember"]),
    ...mapActions(["snackBar"]),
    async saveGoal() {
      // optimistic much?
      this.$auth.user().memberData.stepGoal = +this.stepGoalValue; // coerce to num because todaysprogress uses sanitize num
      this.$parent.close();

      this.saving = true;
      // TODO refactor updateMember to throw in catch so we can use try/catch here
      const response = await this.updateMember({
        memberId: this.$auth.user().id,
        formData: {
          dailyStepGoal: this.stepGoalValue
        }
      });
      this.saving = false;
      if (response.error) {
        const fields = response.error.fields;
        const firstErrorKey = Object.keys(fields)[0];
        this.snackBar({ message: fields[firstErrorKey][0], type: "is-danger" });
      } else {
        this.snackBar({ message: "Your step goal has been updated." });
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.modal-card
  border-radius: $radius
.custom-footer
  display: flex
  justify-content: flex-end
  margin-top: 50px
</style>
